import React from 'react';
import { EmptyLayout } from 'components/Layout';
import { Button, Form, FormGroup, Input, Label, FormFeedback, Card, Col, Row } from 'reactstrap';
import { otpFormValidation } from 'form-validations';
import { connect } from 'react-redux';
import { LoginAction, UIAction } from 'redux/actions';
import AlertMessage from 'components/AlertMessage';
import PageSpinner from 'components/PageSpinner';
import { getOtpKey, } from 'hooks';
import { useNavigate } from 'react-router-dom';

const VerifyOtp = (props) => {

  let [values, setValues] = React.useState({});
  let [errors, setErrors] = React.useState({});
  let [isSubmitted, setIsSubmitted] = React.useState(false);
  let [isValid, setIsValid] = React.useState(true);
  let [showLoader, setShowLoader] = React.useState(false);
  const navigate = useNavigate();
  let [resendDisable, setResendDisable] = React.useState(true);
  const [minutes, setMinutes] = React.useState(1);
  const [seconds, setSeconds] = React.useState(30);
  const pageUrls = [
    { 'page': 'dashboard_data', 'url': '/' },
    { 'page': 'google_analytics', 'url': '/' },
    { 'page': 'campaign_analytics', 'url': '/' },
    { 'page': 'google_analytics_graph', 'url': '/' },
    { 'page': 'top_searches', 'url': '/' },
    { 'page': 'users_list', 'url': '/users' },
    { 'page': 'admin_users_list', 'url': '/backend-users' },
    { 'page': 'reported_users', 'url': '/reported-users' },
    { 'page': 'group_list', 'url': '/users-groups' },
    { 'page': 'group_permissions', 'url': '/manage-group-permissions' },
    { 'page': 'searches', 'url': '/searches' },
    { 'page': 'reported_posts', 'url': '/reported-posts' },
    { 'page': 'failed_urls', 'url': '/failed-urls' },
    { 'page': 'api_documentation', 'url': '/api-documentation' },
    { 'page': 'view_static_pages', 'url': '/faq' },
    { 'page': 'users_locations', 'url': '/geographical-users-count' },
    { 'page': 'campaign_list', 'url': '/campaign-list' },
    { 'page': 'campaign_charges_list', 'url': '/campaign-charges' },
    { 'page': 'campaign_interests', 'url': '/interest' },
    { 'page': 'change_enrichment_settings', 'url': '/settings' },
    { 'page': 'get_app_version', 'url': '/settings' },
  ];

  React.useEffect(() => {
    if (props.loginSuccess) {
      if (props.loginData && props.loginData.is_sup_admin === 1) {
        navigate('/');
      } else {
        const group_permissions = (props.loginData && props.loginData.group_permissions) ? props.loginData.group_permissions : [];
        const user_permissions = (props.loginData && props.loginData.user_permissions) ? props.loginData.user_permissions : [];
        for (let i = 0; i < pageUrls.length; i++) {
          if (group_permissions.includes(pageUrls[i].page) || user_permissions.includes(pageUrls[i].page)) {
            navigate(`${pageUrls[i].url}`);
            break;
          }
        }
        setShowLoader(false);
        props.showMessages({ status: 'danger', message: 'You do not have permission to access any page' })
      }
    }
  }, [props.loginSuccess]);

  const handleSubmit = () => {
    setIsSubmitted(true);
    if (isValid) {
      values['key'] = getOtpKey();
      props.verifyOtp(values);
    }
  }

  const handleChange = (event) => {
    setValues({
      ...values, [event.target.name]: event.target.value
    })
  };

  React.useEffect(() => {
    const validationErrors = otpFormValidation(values);
    setIsValid(Object.keys(validationErrors).length === 0);
    setErrors(validationErrors);
  }, [values]);

  const navigateToLogin = () => {
    props.loginSuccessClear();
    navigate('/login');
  }

  const resendOtp = () => {
    setResendDisable(true);
    setMinutes(1);
    setSeconds(30);
    props.resend({ key: props.loginKey, action: 'resend' });
  }

  React.useEffect(() => {
    if (seconds === 0 && minutes === 0) {
      setResendDisable(false);
    }
  }, [seconds])



  React.useEffect(() => {
    if (props.loginKey) {
      const interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        }

        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(interval);
          } else {
            setSeconds(59);
            setMinutes(minutes - 1);
          }
        }
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [seconds]);








  return (
    <EmptyLayout>

      <Row className={'login-page-row'} >
        {(showLoader) ? <PageSpinner />
          : <Col md={6} lg={4}>
            <div style={{ minHeight: 55 }}><AlertMessage /></div>

            <Card body className="login-card">
              <Form>
                <div className="text-center pb-4">
                  Enter your OTP to login
                </div>
                <FormGroup>
                  <Label for={'otp'}></Label>
                  <Input
                    type="text"
                    name="otp"
                    id="otp"
                    onChange={handleChange}
                    autoComplete={'off'}
                    value={(values && values.otp) ? values.otp : ''}
                    placeholder={'OTP'}
                  />
                  {(isSubmitted && errors.otp && !values.otp) && <FormFeedback >{errors.otp} </FormFeedback>}
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col>
                      <Button
                        size="lg"
                        color="primary"
                        className="border-0"
                        block
                        onClick={() => handleSubmit()}
                      >
                        Verify
                      </Button></Col>
                    <Col>
                      {
                        props.loginKey ?
                          seconds > 0 || minutes > 0 ? (
                            <>
                              <Button
                                size="lg"
                                color="primary"
                                className="border-0 btn-disabled"
                                block
                                disabled={resendDisable}
                              >
                                Resend
                              </Button>
                              <div className='resent-otp-text'>
                                Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                                {seconds < 10 ? `0${seconds}` : seconds}
                              </div>
                            </>
                          ) : (
                            <>
                              <Button
                                size="lg"
                                color="primary"
                                className="border-0"
                                block
                                onClick={() => resendOtp()}
                                disabled={resendDisable}
                              >
                                Resend
                              </Button>
                              <div className='resent-otp-text'>Didn't recieve code?</div>
                            </>
                          ) : <Button
                            size="lg"
                            color="primary"
                            className="border-0 btn-disabled"
                            block
                            disabled={resendDisable}
                          >
                            Resend
                          </Button>}
                    </Col>
                  </Row>
                </FormGroup>

                <div style={{ textAlign: 'center', marginTop: 10 }} ><Button className={'btn-link'} outline color="link" onClick={navigateToLogin}>Back to login</Button></div>
              </Form>
            </Card>

          </Col>
        }
      </Row>
    </EmptyLayout>
  )
}

const mapStateToProps = (state) => ({

  loginSuccess: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user && state.loginReducer.loginData.user.api_token) ? state.loginReducer.loginData.user.api_token : null,
  loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
  loginKey: (state.loginReducer && state.loginReducer.loginSuccess && state.loginReducer.loginSuccess.key) ? state.loginReducer.loginSuccess.key : null,
  uiMessage: (state.uiReducer && state.uiReducer.uiMessage) ? state.uiReducer.uiMessage : null
});
const mapDispatchToProps = (dispatch) => ({
  verifyOtp: (payload) => dispatch(LoginAction.verifyOtp(payload)),
  loginSuccessClear: (payload) => dispatch(LoginAction.loginSuccess(null)),
  resend: (payload) => dispatch(LoginAction.tryLogin(payload)), 
  showMessages: (payload) => dispatch(UIAction.showMessages(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VerifyOtp);



